import React, { Fragment, useState, useEffect } from 'react';
import { Row, Col, Container, Card, Button } from 'react-bootstrap';
import HeaderLogged from '../../../components/header_logged'
import Footer from '../../../components/footer'
import Head from '../../../components/head';
import { Navigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCirclePlus, faAlignJustify } from '@fortawesome/free-solid-svg-icons'
import '../../../styles/diario.scss';


function HomeLoggedDiarioScreen() {
    const [cad, setCad] = useState(false)
    const [listar, setListar] = useState(false)
    const [direct, setDirect] = useState(false);
    const [adm, setAdm] = useState(false)
    const nome = localStorage.getItem('nome');
    const getNivel = async () => {
        let user = localStorage.getItem('nivel');
        switch (user) {
            case "Legislador":
                await setDirect("/restrito/leis")
                break;
            case "Licitador":
                await setDirect("/restrito/licitacao")
                break;
            case "Controle Interno":
                await setDirect("/restrito/controle")
                break;
            case "Educação":
                await setDirect("/restrito/educacao")
                break;
            case "Obras":
                await setDirect("/restrito/obras")
                break;
            case "Saude":
                await setDirect("/restrito/saude")
                break;
            case "Ouvidor":
                await setDirect("/restrito/ouvidoria")
                break;
            case "RH":
                await setDirect("/restrito/rh")
                break;
            case "Administrador":
                await setAdm(true);
                break;
            case "Diario":
                await setDirect(false)
                break;
        }
    }

    const redireciona = async () => {
        await getNivel();
    }

    useEffect(() => {
        redireciona()
    }, [])

    if (listar) {
        return <Navigate to={{ pathname: '/restrito/diario/listar' }} />
    }

    if (cad) {
        return <Navigate to={{ pathname: '/restrito/diario/cadastrar' }} />
    }

    return (
        <Fragment>
            <Head titulo="Transparência - Diário Eletrônico" />
            <HeaderLogged />
            <Container>
                <h5>Bem vindo, {nome}, o que deseja fazer?</h5><br />
                <Row xs={1} lg={2}>
                    <Col>
                        <Card className='card-list' onClick={e => setCad(true)}>
                            <Card.Body>
                                <Row xs={1}>
                                    <Col>
                                        <Row xs={2}>
                                            <Col xs={3}>
                                                <FontAwesomeIcon className='icon-cad' icon={faFileCirclePlus} />
                                            </Col>
                                            <Col xs={9}>
                                                <p className='titulo-lei'>Cadastrar Diário</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card className='card-list' onClick={e => setListar(true)}>
                            <Card.Body>
                                <Row xs={1}>
                                    <Col>
                                        <Row xs={2}>
                                            <Col xs={3}>
                                                <FontAwesomeIcon className='icon-cad' icon={faAlignJustify} />
                                            </Col>
                                            <Col xs={9}>
                                                <p className='titulo-lei'>Listar Diários</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                {adm ?
                    <Fragment>
                        <br /><br />
                        <Link to={'/restrito'}>
                            <Button variant="danger" type="button">
                                Voltar
                            </Button>
                        </Link>
                    </Fragment> : ''}
            </Container>
            <Footer />
        </Fragment>
    );
}

export default HomeLoggedDiarioScreen;